import { all, call } from 'redux-saga/effects';
import { onFetchAppModulesStart } from './fetchAppModules';
import { onSelectAppModulesStart } from './selectAppModules';

export function* plansSagas() {
  yield all([call(onFetchAppModulesStart), call(onSelectAppModulesStart)]);
}
